import inviteType from "./walletTypes";

const initialState = {
  allWallets: [],
  loading: false,
  storeWallet: {},
  showWallet: {},
  editInvite: {},
  deleteWallet: {},
  myWallets: {},
  filterInvites: [],
  searchInvites: [],
};
export default function walletReducer(state = initialState, action) {
  switch (action.type) {
    case inviteType.GET_ALL_WALLETS:
      return {
        ...state,
        allWallets: action.payLoad?.data?.data,
      };
    case inviteType.STORE_WALLET:
      return {
        ...state,
        storeWallet: action.payLoad.data.data,
      };
    case inviteType.DELETE_WALLET:
      return {
        ...state,
        deleteWallet: action.payLoad.data.data,
      };
    case inviteType.EDIT_INVITE:
      return {
        ...state,
        editInvite: action.payLoad.data.data,
      };
    case inviteType.SHOW_WALLET:
      return {
        ...state,
        showWallet: action.payLoad.data.data,
      };
    case inviteType.SHOW_MY_WALLET:
      return {
        ...state,
        myWallets: action.payLoad?.data,
      };
    case inviteType.FILTER_INVITES:
      return {
        ...state,
        filterInvites: action.payLoad.data.data,
      };
    case inviteType.SEARCH_INVITES:
      return {
        ...state,
        searchInvites: action.payLoad.data.data,
      };

    case inviteType.LOADING_WALLETS:
      return {
        ...state,
        loading: action.payLoad,
      };
    default:
      return state;
  }
}
